export default {
  "Preschool & Kindergarten - Pre-Nursery (18-24 months old)": 398,
  "Preschool & Kindergarten - Nursery (25-36 months old)": 396,
  "Preschool & Kindergarten - PreSchool (3 years old)": 399,
  "Preschool & Kindergarten - Pre-Kinder (4 years old)": 397,
  "Preschool & Kindergarten - Kindergarten (5 years old)": 395,
  "Primary - Grade 1": 436,
  "Primary - Grade 2": 437,
  "Primary - Grade 3": 438,
  "Primary - Grade 4": 439,
  "Primary - Grade 5": 440,
  "Secondary - Grade 6": 441,
  "Secondary - Grade 7": 442,
  "Secondary - Grade 8": 443,
  "Secondary - Grade 9": 444,
  "High School - Grade 10": 445,
  "High School - Grade 11": 446,
  "High School - Grade 12": 447
};
